import { CurrencyInputOptions } from 'vue-currency-input'

export const VueCurrencyOptions: CurrencyInputOptions = {
  currency: 'BRL',
  locale: 'pt-BR',
  autoDecimalMode: true
}
